<section class="cr-content">
  <h3 class="cr-header">
    <span class="cr-title">
      {{
        "currencyRate.title"
          | translate
            : {
                title:
                  (fromControl.value.amount || 0) +
                  " " +
                  fromCurrency()?.symbol,
              }
      }}
    </span>
    <strong class="cr-subtitle"
      >{{ toControl.value.amount || 0 }} {{ toCurrency()?.symbol }}</strong
    >
  </h3>

  <form class="cr-form" [formGroup]="form" autocomplete="off" novalidate>
    <div class="cr-control" formGroupName="from">
      <fu-simple-input
        class="cr-control-amount"
        formControlName="amount"
        placeholder="0"
        [useOutlineLabel]="false"
        [maskPattern]="'separator.' + fromCurrency()?.decimals"
        [dropSpecialCharacters]="false"
        (focusout)="normalizeOnFocusOut($event, fromAmountCtrl)"
        [decimalMarker]="['.', ',']"
        (focused)="lastEdited.set('from')"
      />

      <fu-select
        class="cr-control-currency"
        formControlName="currency"
        activeItemIcon="checkmark"
        [items]="fromCurrencyList()"
      />
    </div>

    <div class="cr-control" formGroupName="to">
      <fu-simple-input
        class="cr-control-amount"
        formControlName="amount"
        placeholder="0"
        [useOutlineLabel]="false"
        (focusout)="normalizeOnFocusOut($event, toAmountCtrl)"
        [maskPattern]="'separator.' + +toCurrency()?.decimals"
        [dropSpecialCharacters]="false"
        [decimalMarker]="['.', ',']"
        (focused)="lastEdited.set('to')"
      />

      <fu-select
        class="cr-control-currency"
        [items]="toCurrencyList()"
        formControlName="currency"
        activeItemIcon="checkmark"
      />
    </div>

    <iw-button
      class="cr-swap-btn"
      size="s"
      uiType="custom"
      (clicked)="swap()"
      onlyIcon
    >
      <fu-icon iconName="swap" size="16"></fu-icon>
    </iw-button>
  </form>
</section>
